import { addDays, set } from 'date-fns'
import { getPrevDateByDay } from '../../common/utils/date'

type CalendarRange = {
  end: Date
  start: Date
}

export const getCalendarRange = (date: Date): CalendarRange => ({
  end: set(addDays(getPrevDateByDay(date, 'sunday'), 7), {
    hours: 0,
    milliseconds: 0,
    minutes: 0,
    seconds: 0,
  }),
  start: set(getPrevDateByDay(date, 'sunday'), {
    hours: 0,
    milliseconds: 0,
    minutes: 0,
    seconds: 0,
  }),
})
